import styled from '@emotion/styled';
import Info from '@engineering/icons/info';
import { Ui } from '@silvertours/front-shared';
import { css } from '@emotion/react';

const Wrapper = styled.div`
  grid-area: age;
  padding-left: 1rem;
  display: grid;
  grid-template:
    'icon label input input2' 2rem
    '. error error error' 1fr / 2rem min-content auto auto;
  gap: 0 0.5rem;
  align-items: center;

  @media (min-width: 634px) {
    padding-top: 0.75rem;
  }
`;

const StyledIcon = styled(Info)`
  fill: ${({ theme }) => theme.colors.brand.green120};
  width: 2rem;
  grid-area: icon;
  vertical-align: bottom;
  cursor: pointer;
`;

const StyledLabel = styled.label`
  grid-area: label;
  line-height: 1.5;
  white-space: nowrap;
`;

const CompactInput = styled.input<{
  $isInvalid?: boolean;
}>`
  grid-area: input;
  margin: 0;
  padding: 0 0.5rem;
  width: 3.5625rem;
  justify-self: start;
  height: min-content;
  border: ${({ theme, $isInvalid }) =>
    `1px solid ${$isInvalid ? theme.colors.accent.red100 : theme.colors.neutral.grey100}`};
  border-radius: ${({ theme }) => theme.radius.xs};
  outline: 0;
  font-size: 0.875rem;
  font-family: inherit;
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.neutral.grey160};
  background-color: ${({ theme }) => theme.colors.neutral.white100};
  background-clip: padding-box; /* removes inner shadow on iOS */
  box-shadow: none; /* removes validation outlines in Firefox */

  ${({ theme, $isInvalid }) =>
    !$isInvalid &&
    css`
      &:hover,
      &:focus {
        border-color: ${theme.colors.neutral.grey140};
      }
    `}

  &::placeholder {
    color: ${({ theme }) => theme.colors.neutral.grey140};
    opacity: 1; /* fix opacity in Firefox 19+ */
  }

  &:focus::placeholder {
    color: transparent;
  }

  &::-ms-clear {
    display: none;
  }

  &[readonly],
  &[disabled] {
    border-color: ${({ theme, $isInvalid }) =>
      $isInvalid ? theme.colors.accent.red100 : 'currentcolor'};
    color: ${({ theme }) => theme.colors.neutral.grey80};
    cursor: not-allowed;
    pointer-events: none;

    &::placeholder {
      color: currentcolor;
    }
  }
`;

const StyledErrorMessage = styled(Ui.ErrorMessage)`
  grid-area: error;
  margin: 0;
  padding: 0;
  line-height: 1.2;
  text-wrap: pretty;
`;

const StyledTooltip = styled(Ui.Tooltip)`
  border-radius: 100%;
`;

export {
  Wrapper,
  StyledIcon,
  StyledLabel,
  CompactInput,
  StyledErrorMessage,
  StyledTooltip,
};
